import { Tabs } from '@mantine/core';
import cs from 'classnames';
import type { FC } from 'react';
import { VALUE_TAB } from '@/Module/Auth/Component/WelcomeSuggestSubscription/WelcomeSubscriptionTab';
import { IconFlash } from '@/Module/Icon';
import { SubscriptionPlan } from '@/Module/Subscription/Component';
import styles from '@/Module/Subscription/Component/SubscriptionPageContainer/subscriptionTab.module.scss';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
interface IGroupGroup {
  duration: number;
  items: ISubscriptionPlan[];
}
interface IGroupGroupProps {
  iGroupGroup: IGroupGroup[];
  color?: string;
}
export const MONTH_PERSIAN: Record<number, string> = {
  30: '1 ماهه',
  31: '1 ماهه',
  93: '3 ماهه',
  90: '3 ماهه',
  186: '6 ماهه',
  275: '9 ماهه',
  270: '9 ماهه',
  365: 'سالانه'
};
export const WRAP_STYLE: {
  [key: string]: string;
} = {
  pink: 'border-[2px] border-pinkFive bg-pinkOne',
  blue: 'border-[2px] border-blueFive bg-blueOne',
  green: 'border-[2px] border-greenFive bg-greenOne',
  orange: 'border-[2px] border-orangeFive bg-orangeOne'
};
const SubscriptionPageTabInner: FC<IGroupGroupProps> = ({
  iGroupGroup,
  color
}) => {
  return <Tabs aria-label="primary" defaultValue="2" unstyled classNames={{
    root: 'flex flex-col gap-3 ',
    list: 'flex absolute top-0 right-0  text-center  flex-wrap bg-blueOne mt-16 flex-row-reverse  border-2 border-blueThree w-full mx-auto  flex-nowrap rounded-md  '
  }} data-sentry-element="Tabs" data-sentry-component="SubscriptionPageTabInner" data-sentry-source-file="SubscriptionPageTabInner.tsx">
      <Tabs.List data-sentry-element="unknown" data-sentry-source-file="SubscriptionPageTabInner.tsx">
        {iGroupGroup.map((group, index) => <div className={cs('relative ', VALUE_TAB[group.duration].width)} key={group.duration}>
            <div className="absolute  bottom-[calc(100%+10px)] left-0 ">
              <div className={cs('text-blueFive font-bold pr-[30px] max-w-[120px] text-right', group.duration > 100 && '!text-redFour')}>
                {VALUE_TAB[group.duration].percentage}
              </div>
              {VALUE_TAB[group.duration].percentage && <IconFlash size="small" className="absolute -bottom-2 right-0 " />}
            </div>
            <Tabs.Tab key={VALUE_TAB[group.duration]?.month} value={String(index)} classNames={{
          tab: styles.tab
        }}>
              {VALUE_TAB[group.duration]?.month}
            </Tabs.Tab>
          </div>)}
      </Tabs.List>
      {iGroupGroup.map((group, index) => <Tabs.Panel className={cs(WRAP_STYLE[color || 'blue'], 'flex flex-col gap-8 md:flex-row md:gap-4 lg:gap-6 p-4 sm:p-6')} key={MONTH_PERSIAN[group.duration]} value={String(index)}>
          {group.items.map(plan => <SubscriptionPlan {...plan} key={plan.id} />)}
        </Tabs.Panel>)}
    </Tabs>;
};
export default SubscriptionPageTabInner;